import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { PlaceContext, ObjContext, MakeContext, DefeatContext } from "./context";

export class Peasant extends UnitType {
    readonly id = "peasant";
    readonly displayName = "Peasant";
    description() { return "Provides souls when snatched."; }
    canEnter(ctx: PlaceContext) { return this.inTile(ctx, ["land"], ctx.game.overworld); }
    maxCooldown() { return 5000; }
    moveRange() { return 7; }
    onDefeat(ctx: DefeatContext) { ctx.game.addResource(ctx.attacker.faction, "souls", 1); }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "peasant"); }
    step(ctx: ObjContext) { this.wander(ctx); }
}
